import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  FileTransferStateType,
  FileTransferEventName,
  type DownloadableFile,
} from '../fileTransfer.type';
import type { AppDispatch, RootState } from '../../../stores/redux';
import {
  getFileTransferFilesAvailable,
  getFileTransferFilesUploaded,
  getRequestMemberIds,
} from '../fileTransfer.selector';
import { sendFileTransferRealtimeMessage } from '../../../components/call/fileTransferDialog/sendFileTransferRealtimeMessage';
import { setFileTransferState, setFilesAvailable } from '../fileTransfer.slice';

export const setFileAvailable = createAsyncThunk<
  void,
  Partial<DownloadableFile>,
  { state: RootState; dispatch: AppDispatch }
>(
  'fileTransfer/setFileAvailable',
  async (newAvailableFile, { getState, dispatch }) => {
    const filesAvailable = getFileTransferFilesAvailable(getState());
    const filesUploaded = getFileTransferFilesUploaded(getState());

    const copyInUploaded = filesUploaded.find(
      (d) => d.name === newAvailableFile.name,
    );

    if (!copyInUploaded) {
      /**
       * Paired with the state reset when clicking "Cancel", this is the main way to stop the transfer during the upload process.
       */
      return;
    }

    const newFile: DownloadableFile = {
      name: copyInUploaded.name,
      size: copyInUploaded.size,
      type: copyInUploaded.type,
      downloadUrl: newAvailableFile.downloadUrl ?? '',
      isDownloaded: false,
    };

    const filesReady = { ...filesAvailable, [newFile.name]: newFile };
    dispatch(setFilesAvailable(filesReady));

    if (
      filesUploaded.length > 0 &&
      filesUploaded.length === Object.values(filesReady).length
    ) {
      const memberIds = getRequestMemberIds(getState());
      dispatch(setFileTransferState(FileTransferStateType.UploadComplete));
      void sendFileTransferRealtimeMessage(
        memberIds,
        FileTransferEventName.DownloadReady,
        { filesReady },
      );
    }
  },
);
